module.exports = __webpack_public_path__ + "static/buttons@2x-3ee296f738460404c38f44e5c1092a71.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/prototyping/buttons@2x.png
// module id = 2610
// module chunks = 168707334958949